import {
  PDKPriorityHighIcon,
  PDKPriorityLowIcon,
  PDKPriorityMediumIcon,
  PDKPriorityNoneIcon,
} from '@/components/ui/pdk-icons';
import type { Deal } from '@/models/registry';
import type { Option } from '../../ui/combobox/combobox-popover';

export const PRIORITY_OPTIONS_MAP: (Option<Deal['priority']> & {
  hotkey: string;
})[] = [
  {
    value: 'none',
    label: 'No Priority',
    icon: <PDKPriorityNoneIcon className="h-3.5 w-3.5" />,
    hotkey: '0',
    abbreviation: 'No Prio',
  },
  {
    value: 'low',
    label: 'Low',
    icon: <PDKPriorityLowIcon className="h-3.5 w-3.5" />,
    hotkey: '1',
    abbreviation: 'Low',
  },
  {
    value: 'medium',
    label: 'Medium',
    icon: <PDKPriorityMediumIcon className="h-3.5 w-3.5" />,
    hotkey: '2',
    abbreviation: 'Med',
  },
  {
    value: 'high',
    label: 'High',
    icon: <PDKPriorityHighIcon className="h-3.5 w-3.5" />,
    hotkey: '3',
    abbreviation: 'High',
  },
] as const;

export const priorityWeight: Record<Deal['priority'], number> = {
  high: 3,
  medium: 2,
  low: 1,
  none: 0,
};
